import { useId, useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { PasswordInput } from '@/components/PasswordInput';
import { describeAuthError, useRegister } from '@liniya/client-core';

const MINIMUM_PASSWORD_LENGTH = 12;

export function RegisterPage() {
  const emailId = useId();
  const register = useRegister();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');

  const mismatch = confirmation.length > 0 && password !== confirmation;
  const tooShort = password.length > 0 && password.length < MINIMUM_PASSWORD_LENGTH;
  const canSubmit =
    email.trim().length > 0 && password.length >= MINIMUM_PASSWORD_LENGTH && !mismatch;

  const submit = (event: FormEvent) => {
    event.preventDefault();
    if (!canSubmit || register.isPending) return;
    register.mutate({ email: email.trim(), password, confirmation });
  };

  return (
    <main className="auth-screen">
      <div className="auth-card">
        <header>
          <span className="line-logo" aria-hidden="true">
            <i />
          </span>
          <h1>Регистрация</h1>
          <p>Создайте аккаунт «Линии».</p>
        </header>

        <form className="auth-form" onSubmit={submit} noValidate>
          {register.isError ? (
            <p className="auth-alert" role="alert">
              {describeAuthError(register.error)}
            </p>
          ) : null}

          <div className="field">
            <label htmlFor={emailId}>Email</label>
            <input
              id={emailId}
              className="input"
              type="email"
              inputMode="email"
              autoComplete="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
              disabled={register.isPending}
            />
          </div>

          <PasswordInput
            label="Пароль"
            value={password}
            onChange={setPassword}
            autoComplete="new-password"
            hint={`Не короче ${MINIMUM_PASSWORD_LENGTH} символов.`}
            {...(tooShort ? { error: `Не короче ${MINIMUM_PASSWORD_LENGTH} символов.` } : {})}
            disabled={register.isPending}
          />

          <PasswordInput
            label="Повторите пароль"
            value={confirmation}
            onChange={setConfirmation}
            autoComplete="new-password"
            {...(mismatch ? { error: 'Пароли не совпадают.' } : {})}
            disabled={register.isPending}
          />

          <button className="primary-btn" type="submit" disabled={!canSubmit || register.isPending}>
            {register.isPending ? 'Создаём аккаунт…' : 'Создать аккаунт'}
          </button>
        </form>

        <p className="auth-switch">
          Уже есть аккаунт? <Link to="/login">Войти</Link>
        </p>
        <p className="auth-legal">
          Продолжая, вы принимаете <a href="/privacy/">политику конфиденциальности</a>
        </p>
      </div>
    </main>
  );
}
